import React from "react";
import Modal from "react-responsive-modal";
import { FaTimes, FaPlus, FaTrash, FaCalendarAlt } from "react-icons/fa";
import DatePicker from "react-datepicker";
import axios from "axios";
import moment from 'moment';
import { apiUri } from "../../../config";
import "./DisclosureDates.css";

import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

const no_duplicates_error = ' is already existed';



class Sec11DisclosureDatesComponent extends React.Component {

	newDisclosureObj = {
		caseId: this.props.caseId,
		disclosureDate: null,
		offeringId: null,
		offeringTypeId: 0,
		offeringPrice: null,
		offeringShares: null,
		offeringDate: null,
		index : 0
						
	}


	constructor(props) {
		super(props);
		this.state = {
			disclosureDates: this.props.disclosureDates.length ? this.props.disclosureDates : [this.newDisclosureObj],
			disclosureDateError: '',
			offeringTypeList: [],
		}
		this.getOfferingType();
	}

	getOfferingType() {
		axios
			.get(apiUri + "/offering/types")
			.then(res => {
				this.setState({
					offeringTypeList: res.data.content
				});
			})
			.catch(err => {
				console.log(err);
			});
	};

	componentWillReceiveProps(nextProps) {
		if (nextProps.disclosureDates) {
			this.setState({
				disclosureDates: [...nextProps.disclosureDates]
			})
		}
	}


	handleCloseSec11CalendarModal = () => {
		this.props.handleOpenSec11CalendarModal(false);
	}

	// Making an API call to save the add/update disclosure date(s)
	handleOnBlur = (event, index) => {
		/*
		console.log("onBlur");
		console.log(event);
		console.log(event.target.name);
		console.log(index);
		*/
		const { disclosureDates } = this.state;
		// Validating date
		
		const { disclosureDate, offeringId } = disclosureDates[index];
		const date = new Date(disclosureDate);
		/*
		console.log("disclosureDate");
		console.log(disclosureDates[index]);
		console.log("disclosureDates");
		console.log(disclosureDates);
		console.log("disclosureDates[index].offeringTypeId");
		console.log(disclosureDates[index].offeringTypeId);
		console.log("moment(date).isValid()");
		console.log(moment(date).isValid());
		*/
		
		if (disclosureDate && moment(date).isValid() && disclosureDates[index].offeringTypeId && (disclosureDates[index].offeringTypeId == 3 || (disclosureDates[index].offeringPrice && disclosureDates[index].offeringShares) )) {
			let disclosures = [];
			const month = (date.getMonth() + 1).toString().padStart(2, '0');
			const day = date.getDate().toString().padStart(2, '0');
			const formattedDate = `${date.getFullYear()}-${month}-${day}`;
			disclosures.push({ ...disclosureDates[index], disclosureDate: formattedDate });
			//console.log("disclosures");
			//console.log(disclosures);
			let myDisclosure = disclosureDates[index];
			myDisclosure.offeringDate = formattedDate;
			if(disclosureDates[index].offeringId) {
				//console.log("disclosuresA");
				axios.put(`${apiUri}/offering/${disclosureDates[index].offeringId}`, myDisclosure)
				.then(res => {
					if (res && res.data && res.data.statusCode === 200) {
						
						this.setState({ disclosureDates });
					}
				})
				.catch(err => {
					console.log(err);
				});
			} else {
				//console.log("disclosuresB");
				disclosureDates[index] = this.newDisclosureObj;
				this.setState({
					disclosureDates: [...disclosureDates]
				});
				axios.post(`${apiUri}/offering/case/${this.props.caseId}`, myDisclosure)
				.then(res => {
					//console.log("res.data");
					//console.log(res.data);
					if (res && res.data && res.data.statusCode === 201) {
						console.log("offeringId")
						console.log(offeringId)
						console.log(myDisclosure.offeringId)
						if(!myDisclosure.offeringId && res.data.content && res.data.content.offeringId && res.data.content.offeringId > 0){
							disclosureDates[index].offeringId = res.data.content.offeringId;
						}
						this.setState({ disclosureDates });
					}
				})
				.catch(err => {
					console.log(err);
				});
			}

		}
		//console.log("disclosureDates2");
		//console.log(disclosureDates);
	}
	
	/*
	useEffect(() => {
        axios.get("api/v1/offering/types")
            .then((response) => {
                setOfferingTypes(response.data);
            })
            .catch((error) => {
                console.error("There was an error fetching offering types!", error);
            });

        // If we are editing, fetch the existing offering data
        if (offeringId) {
            axios.get(`/api/offering/${offeringId}`)
                .then((response) => {
                    setOffering(response.data);
                })
                .catch((error) => {
                    console.error("There was an error fetching the offering!", error);
                });
        }
    }, [offeringId]);
	*/
	// Handling add/edit disclosure date
	handleOnChange = (event, index) => {
		if (event) {
			console.log("onChange");
			console.log(index);
			console.log(event);
			console.log(event.target);
			console.log(event.target.name);
			console.log(1);
			// Handling duplicate disclosure date
			console.log(this.state.disclosureDates);

			console.log(3);
			const updatedDates = [...this.state.disclosureDates];
			console.log(updatedDates);
			//const newDate = updatedDates[index].disclosureDate?new Date(updatedDates[index].disclosureDate) : new Date();
			//if (updatedDates[index] && updatedDates[index].offeringId) {
				console.log(4);
				updatedDates[index][event.target.name] = event.target.value;
				console.log(updatedDates);
			/*} else {
				console.log(5);
				updatedDates[index] = {
					caseId: this.props.caseId,
					offeringId: null,
					disclosureDate: newDate.getTime(),
					offeringId: null,
					offeringTypeId: 0,
					offeringPrice: null,
					offeringShares: null
				};
				console.log(updatedDates);
			}*/
			console.log(6);
			this.setState({
				disclosureDates: [...updatedDates],
				disclosureDateError: ''
			});
			console.log(7);
			console.log("onChange end");
		
		}
	};
	/*
	    // Handling add/edit disclosure date
    handleOnChange = (event, index) => {
        if (event) {
            const newDate = new Date(event);
            // Handling duplicate disclosure date
            if (this.state.disclosureDates.some(dateObj => dateObj.disclosureDate === newDate.getTime())) {
                this.setState({
                    disclosureDateError: moment(newDate).format('YYYY-MM-DD') + no_duplicates_error
                });
            } else {
                const updatedDates = [...this.state.disclosureDates];
                if (updatedDates[index] && updatedDates[index].disclosureId) {
                    updatedDates[index].disclosureDate = newDate.getTime();
                } else {
                    updatedDates[index] = {
                        caseId: this.props.caseId,
                        disclosureId: null,
                        disclosureDate: newDate.getTime(),
                    };
                }
                this.setState({
                    disclosureDates: [...updatedDates],
                    disclosureDateError: ''
                });
            }
        }
    };
    */
	handleDateOnChange = (event, index) => {
		if (event) {
			console.log("onDateChange");
			console.log(index);
			console.log(event);
			const newDate = new Date(event);
			console.log(1);
			// Handling duplicate disclosure date
			console.log(index);
			console.log(this.state.disclosureDates);

			if (this.state.disclosureDates.some(dateObj => dateObj.disclosureDate === newDate.getTime())) {
				console.log(2);
				this.setState({
					disclosureDateError: moment(newDate).format('YYYY-MM-DD') + no_duplicates_error
				});
			} else {
				console.log(3);
				const updatedDates = [...this.state.disclosureDates];
				console.log(updatedDates);
				updatedDates[index].disclosureDate = newDate.getTime();
				//if (updatedDates[index] && updatedDates[index].offeringId) {
					console.log(4);
					updatedDates[index].disclosureDate = newDate.getTime();
					console.log(updatedDates);
				/*} else {
					console.log(5);
					updatedDates[index] = {
						caseId: this.props.caseId,
						offeringId: null,
						disclosureDate: newDate.getTime(),
					};
					console.log(updatedDates);
				}*/
				console.log(6);
				this.setState({
					disclosureDates: [...updatedDates],
					disclosureDateError: ''
				});
				console.log(7);
				console.log("onDateChange end");
			}
		}
	};

	// Adding new disclosure date field
	handleDisclosureDateAdd = (index) => {
		let updatedDisclosureDates = [...this.state.disclosureDates];
		updatedDisclosureDates[index + 1] = this.newDisclosureObj;
		console.log("indexAdd");
		console.log(index);
		this.setState({
			disclosureDates: [...updatedDisclosureDates]
		});
	};

	// Making API call to delete a disclosure date
	deleteDisclosureDate = (index, offeringId) => {
		const { disclosureDates } = this.state;
		console.log("splice");
		console.log(disclosureDates);

		disclosureDates.splice(index, 1);
		console.log(disclosureDates);
		this.setState({
			disclosureDates: [...disclosureDates]
		},() => {
			if (offeringId !== null) {
				axios
				.delete(`${apiUri}/offering/${offeringId}`)
				.then(res => {
					console.log("res");
					console.log(res);
					if (res && (res.status === 204 || res.status === 200)) {
						console.log("res");
						console.log(res.status);
						console.log(disclosureDates.length);
						if(disclosureDates.length === 0){
							disclosureDates.push(this.newDisclosureObj);
							this.setState({
								disclosureDates: [...disclosureDates]
							});
						}
					}
				})
				.catch(err => {
					console.log(err);
				});
			}
		})
	};


	render() {
		return (
			<React.Fragment>
				<Modal
					open={this.props.openSec11CalendarModal}
					onClose={this.handleCloseSec11CalendarModal}
					focusTrapped={false}
				>
					<div className="ModalWindow modaladd">
						<FaTimes className="closeicon" onClick={this.handleCloseSec11CalendarModal} />
						<h3 className="modalHeading">Disclosure Dates</h3>
						<div className="NavDivider"></div>
						<div id={"disclosure-dates-holder"}>
							<table>
								<tr>
									<th width="132px">
										Date
									</th>
									<th width="132px">
										Type
									</th>
									<th width="132px">
										Shares
									</th>
									<th width="132px">
										Price
									</th>
									<th>
										
									</th>
								</tr>
								{this.state.disclosureDates.map((dateObj, index) => (
								<tr key={index}>
									<td>
										
										<div className="datepicker-container">
											<DatePicker
												showIcon
												name="offeringDate"
												className="date_picker pt-0"
												selected={dateObj.disclosureDate}
												onChange={(evt) => this.handleDateOnChange(evt, index)}
												onBlur={(evt) => this.handleOnBlur(evt, index)}
												dateFormat="yyyy-MM-dd"
												placeholderText="YYYY-MM-DD"
												icon="fa calendar-alt"
												autoComplete="off" 
											/>
										</div>
										{this.state.disclosureDateError && <span id="error-style">
											{this.state.disclosureDateError}
										</span>}
										
									</td>
									<td>
										<select
											name="offeringTypeId"
											value={dateObj.offeringTypeId}
											onChange={(evt) => this.handleOnChange(evt, index)}
											onBlur={(evt) => this.handleOnBlur(evt, index)}
											className="form-control"
											defaultValue={dateObj.offeringTypeId}
										>
											<option value="0">Select Type</option>
											{this.state.offeringTypeList.map((type) => (
												<option key={type.offeringTypeId} value={type.offeringTypeId}>
													{type.offeringType}
												</option>
											))}
										</select>
									</td>
									<td>
										
										<input
											type="number"
											name="offeringShares"
											value={dateObj.offeringShares}
											onChange={(evt) => this.handleOnChange(evt, index)}
											onBlur={(evt) => this.handleOnBlur(evt, index)}
											className="searchBox3"
										/>
									</td>
									<td>
									<label>$</label>
										<input
											type="number"
											name="offeringPrice"
											value={dateObj.offeringPrice}
											onChange={(evt) => this.handleOnChange(evt, index)}
											onBlur={(evt) => this.handleOnBlur(evt, index)}
											className="searchBox3"
										/>
									</td>
									<td>
										<span>
											{((this.state.disclosureDates.length > 1) ||
												(this.state.disclosureDates.length === 1 && dateObj.disclosureDate) ) &&
												<FaTrash className="dateOption trash_icon" onClick={() => this.deleteDisclosureDate(index, dateObj.offeringId)} />
											}
											{(index === this.state.disclosureDates.length - 1) &&
												<FaPlus className="dateOption plus_icon" onClick={() => this.handleDisclosureDateAdd(index)} />
											}
										</span>
									</td>
								</tr>
								))}
							</table>
							<div className="textCenter mt-3 mb-3">
								<button className="btn btnC" onClick={this.handleCloseSec11CalendarModal}>Close</button>
							</div>
						</div>
					</div>
					<div className="NavDivider"></div>
				</Modal>
			</React.Fragment>
		)
	}
}

export default Sec11DisclosureDatesComponent;


// WEBPACK FOOTER //
// ./src/common/components/DisclosureDates/Sec11DisclosureDatesComponent.js